const HOST = ""
const SITE_ROOT_PATH = '/news'
const SITE_PATH = HOST + SITE_ROOT_PATH
const REACT_ROUTER_ROOT_PATH = ''


export const CONFIG = {
  "SITE_ROOT_PATH": SITE_ROOT_PATH,
  "PAGE_ROOT_PATH": REACT_ROUTER_ROOT_PATH,
  "API": {
    "GROUPS": SITE_PATH + "/json/groups.json",
    //GROUPS: CONFIG.HOST + "/groups",
    "INFO": SITE_PATH + "/json/",
    //INFO: CONFIG.HOST + "",
    "INFO_EX": ".json",
    //INFO_EX: "",
  },
  "LIMIT_PER_PAGE": 10
}
